

export const ANIMATION = {
  duration: '750ms'
};